import scsConfig from './scs';

describe('SCS share objectives with your team', () => {
  it('adds the email list page after Business Objectives', () => {
    const section = scsConfig.sections.find(({ slug }) => slug === 'objectives');
    const subsectionSlugs = section?.subsections.map(({ slug }) => slug);

    expect(subsectionSlugs).toEqual(['business-objective', 'share-objective-with-team']);
    expect(section?.subsections[0]?.dependsOn).toBe('cover-sheet');

    const subsection = section?.subsections[1];
    expect(subsection?.title).toBe('Share objectives with your team');
    expect(subsection?.dependsOn).toBe('business-objective');

    const page = subsection?.pages[0];
    expect(page?.pageType).toBe('question');
    if (page?.pageType !== 'question') throw new Error('Expected question page');

    expect(page.title).toBe('Share objectives with your team');
    expect(page.questions).toEqual([
      expect.objectContaining({
        questionType: 'select',
        title: 'How would you like to share your objectives?',
        name: 'objective-sharing-method',
        hintOption: 'Select an option',
        rules: { required: true },
        options: [
          'I will share them myself',
          expect.objectContaining({
            option: 'Please share them for me',
            questions: [
              expect.objectContaining({
                questionType: 'textarea',
                textRows: 20,
                title:
                  "Please enter your team members' email addresses below to share your objectives with them.",
                hint: 'You can separate emails using a comma, a space, or by putting each email on a new line.',
                emailList: true,
                rules: { required: true },
              }),
              expect.objectContaining({
                questionType: 'hidden',
                title: 'Share status',
                name: 'share-status',
                actionButtonText: 'Send emails',
                rules: { required: true },
                errorMessages: {
                  required: 'Objectives have not yet been shared',
                },
              }),
            ],
          }),
          'Not applicable',
        ],
      }),
    ]);
  });
});
